import * as React from 'react';
import styled from 'styled-components';
import cl from 'classnames';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  border-radius: 20px;

  &.size-36px {
    width: 36px;
    height: 36px;
    padding: 6px;
  }

  &.size-40px {
    width: 40px;
    height: 40px;
    padding: 10px;
  }
`;

export interface QuestionNumberSizeProps {
  size?: '36px' | '40px';
  children?: React.ReactNode;
}

export const QuestionNumberSize = (props: QuestionNumberSizeProps) => {
  const { size = '36px', children } = props;

  return <Container className={cl('question-number-size', `size-${size}`)}>{children}</Container>;
};
